import React from 'react';

import { motion } from 'framer-motion';

interface ModernCardProps {
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
  hoverable?: boolean;
  padding?: 'none' | 'small' | 'medium' | 'large';
  initial?: Record<string, any>;
  animate?: Record<string, any>;
  whileHover?: Record<string, any>;
  transition?: Record<string, any>;
}

export const ModernCard: React.FC<ModernCardProps> = ({
  className = '',
  children,
  onClick,
  hoverable = true,
  padding = 'medium',
  initial = { opacity: 0, scale: 0.95 },
  animate = { opacity: 1, scale: 1 },
  whileHover = { y: -8, scale: 1.02 },
  transition = { duration: 0.2 },
}) => {
  const paddingStyles = {
    none: '',
    small: 'p-4',
    medium: 'p-6',
    large: 'p-8',
  };

  const hoverStyles = hoverable ? 'hover:shadow-xl transition-all cursor-pointer' : '';

  const cardClasses = [
    'bg-white rounded-xl shadow-lg',
    paddingStyles[padding],
    hoverStyles,
    className,
  ].join(' ');

  return (
    <motion.div
      className={cardClasses}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      initial={initial}
      animate={animate}
      whileHover={hoverable ? whileHover : undefined}
      transition={transition}
    >
      {children}
    </motion.div>
  );
};

export default ModernCard;
